var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowBendDoubleUpLeft = function SvgIconArrowBendDoubleUpLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.207 4.543a1 1 0 0 1 0 1.414L4.414 9.75l3.793 3.793a1 1 0 1 1-1.414 1.414l-4.5-4.5a1 1 0 0 1 0-1.414l4.5-4.5a1 1 0 0 1 1.414 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.707 4.543a1 1 0 0 1 0 1.414L9.914 8.75H12a10 10 0 0 1 10 10 1 1 0 1 1-2 0 8 8 0 0 0-8-8H9.914l2.793 2.793a1 1 0 0 1-1.414 1.414l-4.5-4.5a1 1 0 0 1 0-1.414l4.5-4.5a1 1 0 0 1 1.414 0"
  }))));
};
export default SvgIconArrowBendDoubleUpLeft;